// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3ni0Y","row":"Node_row__DTiWd","label":"Node_label__vw2f_","footer":"Node_footer__1xbxy"};